import { Component, OnDestroy, OnInit } from '@angular/core';
import { map, Observable, Subscription } from 'rxjs';
import {
  WorkshopRegistrationRequestModel,
  WorkshopRegistrationRequestStatus,
} from '../../models/workshop-registration-request.model';
import { ProfileService } from '../../../features/profile/services/profile.service';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';
import { WorkshopModel } from '../../../features/workshop/models/workshop.model';
import { WorkshopService } from '../../../features/workshop/services/workshop.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-upcoming-workshop-list',
  templateUrl: './my-upcoming-workshop-list.component.html',
  styleUrls: ['./my-upcoming-workshop-list.component.css'],
  standalone: false,
})
export class MyUpcomingWorkshopListComponent implements OnInit, OnDestroy {
  // Labels
  myUpcomingWorkshopListLabel: string = '';
  workshopsByMonth: Observable<{ title: string; workshops: WorkshopModel[] }[]>;
  hasWorkshops: Observable<boolean>;

  workshopRegistrationRequests: WorkshopRegistrationRequestModel[] = [];
  approvedWorkshopRegisteredIds: number[] = [];
  pendingWorkshopRegisteredIds: number[] = [];
  rejectedWorkshopRegisteredIds: number[] = [];
  workshopRegisteredIds: number[] = [];
  selectedWorkshopId: number;

  showRegisterPopup: boolean = false;

  constructor(
    private workshopService: WorkshopService,
    private persianTitlesService: PersianTitlesService,
    private profileService: ProfileService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initLabels();
    this.initWorkshopList();
  }

  ngOnDestroy() {}

  private initWorkshopList() {
    this.workshopsByMonth = this.workshopService
      .getWorkShopsGroupedByRegisteringMonth()
      .pipe(
        map((w) => {
          const workshops = w.map((e) => {
            return {
              title: this.getPersianMonthName(e.month),
              workshops: e.workshops,
            };
          });
          this.profileService.getMyWorkshopRegistrationRequests().subscribe(
            (requests) => {
              this.workshopRegistrationRequests = requests;

              this.approvedWorkshopRegisteredIds = requests
                .filter(
                  (w) => w.status == WorkshopRegistrationRequestStatus.Approved,
                )
                .map((req) => req.workshop.id);
              this.rejectedWorkshopRegisteredIds = requests
                .filter(
                  (w) => w.status == WorkshopRegistrationRequestStatus.Rejected,
                )
                .map((req) => req.workshop.id);

              this.pendingWorkshopRegisteredIds = requests
                .filter(
                  (w) => w.status == WorkshopRegistrationRequestStatus.Pending,
                )
                .map((req) => req.workshop.id);

              this.workshopRegisteredIds = requests.map(
                (req) => req.workshop.id,
              );
            },
            () => {},
          );
          return workshops;
        }),
      );
    this.hasWorkshops = this.workshopsByMonth.pipe(
      map((w) => {
        return Object.keys(w).length > 0;
      }),
    );
  }
  getPersianMonthName(key: string): any {
    const monthNames = [
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند',
    ];
    return monthNames[parseInt(key) - 1];
  }

  private initLabels() {
    this.myUpcomingWorkshopListLabel =
      this.persianTitlesService.Items.MyUpcomingWorkshops;
  }

  onRegister(workshopId: number) {
    this.selectedWorkshopId = workshopId;
    this.router.navigateByUrl(
      `workshop/register/${this.selectedWorkshopId}?returnUrl=/`,
    );
  }

  onWorkshopRegisteringPopupHide() {
    this.showRegisterPopup = false;
    this.initWorkshopList();
  }
}
